import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DetailMainComponent } from './detail-main/detail-main.component';

const routes: Routes = [
    {
        path: ':programId/:itemId',
        component: DetailMainComponent,
    },
    {
        path: ':programId',
        component: DetailMainComponent,
    },
    {
        path: '**',
        redirectTo: '',
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class DetailsRoutingModule {}
